import { render, staticRenderFns } from "./FontBigger.vue?vue&type=template&id=0e5fe4d3&scoped=true&"
import script from "./FontBigger.vue?vue&type=script&lang=js&"
export * from "./FontBigger.vue?vue&type=script&lang=js&"
import style0 from "./FontBigger.vue?vue&type=style&index=0&id=0e5fe4d3&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5fe4d3",
  null
  
)

export default component.exports